import { apiController } from '@isomorphic/utils/apiController';
import { userConstants } from '../constants/user.constants';
import { validateEmail } from '../utils';
import { hashPassword } from '../utils/passwordHashing';

const request = (user) => ({ type: userConstants.LOGIN_REQUEST, user });
const success = (user) => ({ type: userConstants.LOGIN_SUCCESS, user });
const failure = (error) => ({ type: userConstants.LOGIN_FAILURE, error });
export const setUserAction = (userId) => request({ userId });
export const loginAction = (username, password, history, errorCallback) => async (dispatch) => {
	dispatch(request({ username }));

	try {
		const hashedPassword = await hashPassword(password);

		const callback = (user) => {
			dispatch(success(user));
			const { loginRedirectionLink } = user?.data || {};
			if (loginRedirectionLink) {
				open(loginRedirectionLink, '_parent');
			} else {
				open('/home', '_parent');
			}
		};

		const callbackError = (baseError) => {
			if (!baseError) {
				errorCallback();
			}
			const errors = baseError?.downStreamErrorDetails;
			if (Array.isArray(errors) && errors.length > 0) {
				dispatch(failure(errors));
				errorCallback(errors);
			}
		};

		const payload = validateEmail(username)
			? { email: username, password: hashedPassword }
			: { loginid: username, password: hashedPassword };

		apiController('POST', 'Q2tClientApiUrl', '/login', payload, true, callback, callbackError);
	} catch (error) {
		const hashingError = {
			message: 'Unable to process login. Please try again.',
			code: 'HASHING_ERROR',
		};
		dispatch(failure([hashingError]));
		errorCallback([hashingError]);
	}
};
